import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/contacts-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/contacts-2.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/contacts-3.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/contacts-4.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/ig.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/tg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/vk.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/EventPreviewContainer/EventPreviewContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventPreviewSection/EventPreviewSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PartnerList/PartnerList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/PartnerSection/PartnerSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PopupModal/PopupModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ReviewList/ReviewList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScheduleList/ScheduleList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ScheduleSection/ScheduleSection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReviewSection/ReviewSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SliderList/SliderList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/SliderSection/SliderSection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReviewText/ReviewText.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReviewContent/ReviewContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ContactsSection/ContactsSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TheaterSection/TheaterSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/loaders/image-loader.js");
;
import(/* webpackMode: "eager" */ "/app/src/styles/page.scss");
